import styled from 'styled-components'
import tw from 'twin.macro'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { Tooltip, withStyles } from '@material-ui/core'

export const StyledList = styled.ul`
  ${tw`list-disc list-inside p-3 border mt-2`}
  color: #8b8d99;
  background-color: #efefef;
  font-family: Varela Round;
  font-size: 14px;
  border-color: rgb(217, 217, 217);
`
export const InputHeader = styled.div`
  ${tw`uppercase w-full relative pb-1 ml-2`}
  color: #000000;
  font-size: 14px;
  font-family: Montserrat;
  font-weight: bold;
`
export const StyledDatePicker = styled(KeyboardDatePicker)`
  .MuiInput-underline:hover:not(.Mui-disabled)::before {
    border-bottom: none;
  }
  .MuiInput-underline::before {
    border-bottom: none;
  }
  .MuiInput-underline.Mui-disabled::before {
    border-bottom: none;
  }
  .MuiInputLabel-root {
    ${tw`uppercase w-full relative pb-1`}
    color: #000000;
    font-family: Montserrat;    
    font-weight: bold;
  }
  .MuiInput-formControl {
    ${tw`mt-0 pl-2 pt-1.5 pb-0.5`}
    height: 40px;
  }
  .MuiInputBase-root {
    ${tw`border`}
    width: 161px;
    font-size: 13px;
    font-family: Varela Round;
  }
  .MuiButtonBase-root {
    ${props => props.noButton && tw`hidden`}
  }
`
export const StyledToolTip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#efefef',
    maxWidth: '365px',
    padding: '20px',
    fontSize: '12px',
    color: 'black',
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
  },
  arrow: {
    color: '#efefef',
  }
}))(Tooltip)
